import * as Google from './init';

export default Google;